export const FEATURE_FLAGS = {
    CLASS_PROGRESS_REPORT: true,
    MOCK_ERSS_SKILLS_DIAGNOSTIC: false,
    DYSLEXIA_PARENT_LETTERS: true,
};